module.exports = __webpack_public_path__ + "static/media/24-min.jpg.a9cf1615.webp";